import ActionTypes from '../actionsTypes'

export interface AuthStore {
  authenticated: boolean
  apiToken?: string
}

interface Action {
  type: string
  payload: any
}

const initialState: AuthStore = {
  authenticated: false,
  apiToken: undefined,
}

export default (state: AuthStore = initialState, action: Action): AuthStore => {
  switch (action.type) {
    case ActionTypes.SET_API_TOKEN:
      return Object.assign({}, state, {
        authenticated: true,
        apiToken: action.payload.token,
      })
    default:
      return state
  }
}
